import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Slider from "react-slick";
import Skill_Right_API from "./Skill_Right_API";
import Skill_left_API from "./Skill_left_API";

const commonSettings = {
  dots: false,
  arrows: false,
  slidesToShow: 6,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 20000,
  cssEase: "linear",
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 991, settings: { slidesToShow: 4 } },
    { breakpoint: 767, settings: { slidesToShow: 3 } },
    { breakpoint: 375, settings: { slidesToShow: 2 } },
  ],
};

const rightSettings = { ...commonSettings, rtl: true };
const leftSettings = { ...commonSettings, rtl: false };

const Skills = () => {
  return (
    <section className="skills gp ">
      <div className="skill-inner ">
        <div className="skill-right-slider ">
          <Slider {...rightSettings}>
            {Skill_Right_API.map((val) => (
              <div key={val.iconName} className="skill-one ">
                <div className="skill-icon">
                  <img src={val.icon} alt={val.iconName} loading="lazy" />
                </div>
                <h6>{val.iconName}</h6>
              </div>
            ))}
          </Slider>
        </div>

        <div className="skill-right-slider">
          <Slider {...leftSettings}>
            {Skill_left_API.map((val) => (
              <div key={val.iconName} className="skill-one">
                <div className="skill-icon">
                  <img src={val.icon} alt={val.iconName} loading="lazy" />
                </div>
                <h6>{val.iconName}</h6>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Skills;
